<div
    class="cmps-cdk-d-flex cmps-cdk-border-width-1p cmps-cdk-border-solid cmps-cdk-border-color-grey-300 cmps-cdk-border-radius-4p cmps-cdk-h-50px"
    *ngIf="readonly !== true && disabled !== true"
>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.User
        "
        *ngIf="canSelectUser === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.User].label"
            (click)="_state.selectedPopulation = _Population.User"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.User].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot5 cmps-cdk-flex-grow-1 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot25"
            *ngIf="_state.selectedPopulation === _Population.User"
        >
            <div
                class="cmps-cdk-flex-50"
                *ngIf="
                    singlePopulationSelect && _state.lastSelectedItem != null
                "
            >
                <span class="cmps-cdk-line-clamp-2">
                    {{ _state.lastSelectedItem.label }}
                </span>
            </div>
            <div
                class="cmps-cdk-flex-grow-1"
                [class.cmps-cdk-flex-50]="
                    singlePopulationSelect && _state.lastSelectedItem != null
                "
            >
                <button
                    type="button"
                    class="cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white cmps-cdk-font-bold cmps-cdk-min-h-34p cmps-cdk-px-1 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-100pct"
                    (click)="_onUserClick(_Population.User)"
                >
                    <span>Select</span>
                </button>
            </div>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Team
        "
        *ngIf="canSelectTeam === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Team].label"
            (click)="_state.selectedPopulation = _Population.Team"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Team].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot5 cmps-cdk-flex-grow-1 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-cg-0dot25"
            *ngIf="_state.selectedPopulation === _Population.Team"
        >
            <div
                class="cmps-cdk-flex-50"
                *ngIf="
                    singlePopulationSelect && _state.lastSelectedItem != null
                "
            >
                <span class="cmps-cdk-line-clamp-2">
                    {{ _state.lastSelectedItem.label }}
                </span>
            </div>
            <div
                class="cmps-cdk-flex-grow-1"
                [class.cmps-cdk-flex-50]="
                    singlePopulationSelect && _state.lastSelectedItem != null
                "
            >
                <button
                    type="button"
                    class="cmps-cdk-bg-color-blue-100 cmps-cdk-border-radius-4px cmps-cdk-border-width-0p cmps-cdk-color-white cmps-cdk-font-bold cmps-cdk-min-h-34p cmps-cdk-px-1 cmps-cdk-cursor-pointer cmps-cdk-d-inline-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-100pct"
                    (click)="_onUserClick(_Population.Team)"
                >
                    <span>Select</span>
                </button>
            </div>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Lob
        "
        *ngIf="canSelectLob === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Lob].label"
            (click)="_state.selectedPopulation = _Population.Lob"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Lob].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.Lob"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.lobs"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.Lob, $event, lob)"
                #lob
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Region
        "
        *ngIf="canSelectRegion === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Region].label"
            (click)="_state.selectedPopulation = _Population.Region"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Region].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.Region"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.regions"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.Region, $event, region)"
                #region
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Area
        "
        *ngIf="canSelectArea === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Area].label"
            (click)="_state.selectedPopulation = _Population.Area"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Area].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.Area"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.areas"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.Area, $event, area)"
                #area
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Site
        "
        *ngIf="canSelectSite === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Site].label"
            (click)="_state.selectedPopulation = _Population.Site"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Site].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.Site"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.sites"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.Site, $event, site)"
                #site
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.SuperGroup
        "
        *ngIf="canSelectSuperGroup === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="
                _PopulationPropsMap[_Population.SuperGroup].label
            "
            (click)="_state.selectedPopulation = _Population.SuperGroup"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.SuperGroup].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.SuperGroup"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.superGroups"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="
                    _onChange(_Population.SuperGroup, $event, superGroup)
                "
                #superGroup
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.PeerGroup
        "
        *ngIf="canSelectPeerGroup === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="
                _PopulationPropsMap[_Population.PeerGroup].label
            "
            (click)="_state.selectedPopulation = _Population.PeerGroup"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.PeerGroup].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.PeerGroup"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.peerGroups"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.PeerGroup, $event, peerGroup)"
                #peerGroup
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-border-r-width-1px cmps-cdk-border-r-solid cmps-cdk-border-r-color-grey-300 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Role
        "
        *ngIf="canSelectRole === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Role].label"
            (click)="_state.selectedPopulation = _Population.Role"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Role].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.Role"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.roles"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.Role, $event, role)"
                #role
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.Queue
        "
        *ngIf="canSelectQueue === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="_PopulationPropsMap[_Population.Queue].label"
            (click)="_state.selectedPopulation = _Population.Queue"
        >
            <cmps-icon
                [svgIcon]="_PopulationPropsMap[_Population.Queue].icon"
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.Queue"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.queues"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="_onChange(_Population.Queue, $event, queue)"
                #queue
            ></ng-select>
        </div>
    </div>
    <div
        class="cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center"
        [class.cmps-cdk-flex-grow-1]="
            _state.selectedPopulation === _Population.PopulationGroup
        "
        *ngIf="canSelectPopulationGroup === true"
    >
        <button
            type="button"
            class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-d-flex cmps-cdk-align-items-center cmps-cdk-justify-content-center cmps-cdk-w-50px cmps-cdk-min-w-50px cmps-cdk-h-100pct"
            [cmpsTooltipTrigger]="
                _PopulationPropsMap[_Population.PopulationGroup].label
            "
            (click)="_state.selectedPopulation = _Population.PopulationGroup"
        >
            <cmps-icon
                [svgIcon]="
                    _PopulationPropsMap[_Population.PopulationGroup].icon
                "
            ></cmps-icon>
        </button>
        <div
            class="cmps-cdk-pr-0dot25 cmps-cdk-flex-grow-1"
            *ngIf="_state.selectedPopulation === _Population.PopulationGroup"
        >
            <ng-select
                [placeholder]="'Select'"
                [options]="_state.populationGroups"
                [ngModel]="_state.lastSelectedItem?.id"
                (selected)="
                    _onChange(
                        _Population.PopulationGroup,
                        $event,
                        populationGroup
                    )
                "
                #populationGroup
            ></ng-select>
        </div>
    </div>
</div>

<div *ngIf="!singlePopulationSelect">
    <ng-container *ngFor="let g of _state.selected">
        <button
            class="cmps-cdk-bg-color-grey-400 cmps-cdk-color-white"
            cmpsChip
            variant="a"
            [selectable]="false"
        >
            <div [cmpsTooltipTrigger]="g.populationProps.label">
                <cmps-icon [svgIcon]="g.populationProps.icon"></cmps-icon>
            </div>
            <span class="cmps-cdk-pl-0dot25">{{ g.label }}</span>
            <button
                type="button"
                class="cmps-cdk-bg-color-transparent cmps-cdk-border-width-0p not:disabled:cmps-cdk-cursor-pointer cmps-cdk-p-0 cmps-cdk-color-white cmps-cdk-pl-0dot25"
                [cmpsTooltipTrigger]="'Remove'"
                (click)="_state.selected.delete(g)"
                *ngIf="readonly !== true && disabled !== true"
            >
                <cmps-icon svgIcon="close"></cmps-icon>
            </button>
        </button>
    </ng-container>
</div>
